import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import {
  Image,
  SectionHeader,
  Button,
  PopUp,
  YouTubePlayer,
} from 'components';
import './Video.scss';

class Video extends Component {
  constructor() {
    super();

    this.state = {
      visibility: false,
    };
  }

  handleData = data => {
    this.showPopUp(data);
  };

  showPopUp = (visibility = true) => {
    this.setState({ visibility });
  };

  render() {
    const { visibility } = this.state;

    return (
      <StaticQuery
        query={graphql`
          query {
            image: file(relativePath: { eq: "culture/holacracy.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <LazyLoad once offset={200}>
            <div className={'career-video__section'}>
              <Image
                src={data.image.childImageSharp.fluid}
                additionalClass={'career-video__container'}
              />
              <div className={'career-video__text'}>
                <SectionHeader
                  additionalClass={'headline--centered'}
                  color={'white'}
                  size={'small'}
                  lineColor={'white'}
                  headingType={2}
                >
                  The way we are, the way we work
                </SectionHeader>
                <Button transparent color={'white'} onClick={this.showPopUp}>
                  <span className="career-video__play" />
                </Button>
              </div>

              <PopUp
                visible={visibility}
                id={'career-video-popup'}
                visibilityHandler={this.handleData}
                additionalClass="career-video__player"
              >
                <YouTubePlayer
                  title={"Why join Boldare? Cause it's awesome to work with us!"}
                  src={'https://www.youtube.com/watch?v=1hQMCpMH2EM'}
                />
              </PopUp>
            </div>
          </LazyLoad>
        )}
      />
    );
  }
}

export default Video;
